module.exports = __webpack_public_path__ + "static/media/04.8148faf8.png";